module.exports = __webpack_public_path__ + "assets/img/1_1599.0ca8cfc0.jpg";